var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "attach_money"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1787_6031",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1787_6031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "attach_money_2",
    d: "M11.0242 21V18.85C10.1409 18.65 9.37839 18.2667 8.73672 17.7C8.09505 17.1333 7.62422 16.3333 7.32422 15.3L9.17422 14.55C9.42422 15.35 9.79505 15.9583 10.2867 16.375C10.7784 16.7917 11.4242 17 12.2242 17C12.9076 17 13.4867 16.8458 13.9617 16.5375C14.4367 16.2292 14.6742 15.75 14.6742 15.1C14.6742 14.5167 14.4909 14.0542 14.1242 13.7125C13.7576 13.3708 12.9076 12.9833 11.5742 12.55C10.1409 12.1 9.15755 11.5625 8.62422 10.9375C8.09089 10.3125 7.82422 9.55 7.82422 8.65C7.82422 7.56667 8.17422 6.725 8.87422 6.125C9.57422 5.525 10.2909 5.18333 11.0242 5.1V3H13.0242V5.1C13.8576 5.23333 14.5451 5.5375 15.0867 6.0125C15.6284 6.4875 16.0242 7.06667 16.2742 7.75L14.4242 8.55C14.2242 8.01667 13.9409 7.61667 13.5742 7.35C13.2076 7.08333 12.7076 6.95 12.0742 6.95C11.3409 6.95 10.7826 7.1125 10.3992 7.4375C10.0159 7.7625 9.82422 8.16667 9.82422 8.65C9.82422 9.2 10.0742 9.63333 10.5742 9.95C11.0742 10.2667 11.9409 10.6 13.1742 10.95C14.3242 11.2833 15.1951 11.8125 15.7867 12.5375C16.3784 13.2625 16.6742 14.1 16.6742 15.05C16.6742 16.2333 16.3242 17.1333 15.6242 17.75C14.9242 18.3667 14.0576 18.75 13.0242 18.9V21H11.0242Z",
    fill: "url(#paint0_linear_1787_6031)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1787_6031",
    x1: 11.9992,
    y1: 3,
    x2: 11.9992,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachMoney);
export default __webpack_public_path__ + "static/media/attach_money.97bea02b7ba5446933ec58f1bb0543f1.svg";
export { ForwardRef as ReactComponent };